import axios from 'axios';

const SESSION_KEY = 'adminSession';

export const getAdminSession = () => {
  try {
    const session = JSON.parse(localStorage.getItem(SESSION_KEY));
    return session && session.token ? session : null;
  } catch (error) {
    localStorage.removeItem(SESSION_KEY);
    return null;
  }
};

export const storeAdminSession = (session) => {
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
};

export const clearAdminSession = () => {
  localStorage.removeItem(SESSION_KEY);
  localStorage.removeItem('password');
};

axios.interceptors.request.use((config) => {
  const session = getAdminSession();
  if (session) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${session.token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config?.url?.endsWith('/auth/google')) {
      clearAdminSession();
      window.dispatchEvent(new Event('admin-auth-expired'));
    }
    return Promise.reject(error);
  }
);

